(function () {

    /*
    * Add Lines to mobile nav
    -----------------------------------------------------*/
    // Info: Script is located in the divi Theme-Options body code Field

    function onReady(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    // Divi erstellt das mobile Menü (ul.et_mobile_menu) erst per JavaScript.
    // Warten, bis es im DOM ist, damit auch die geklonten Menüpunkte erfasst werden.
    function whenMobileMenuReady(fn) {
        if (document.querySelector('ul.et_mobile_menu')) {
            fn();
            return;
        }

        var observer = new MutationObserver(function () {
            if (document.querySelector('ul.et_mobile_menu')) {
                observer.disconnect();
                fn();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    /*
    * Navigation functionality enhancements
    -----------------------------------------------------*/
    function enhanceNav() {
        // Open sub-menu
        whenMobileMenuReady(function () {
            var menuItems = document.querySelectorAll('body ul.et_mobile_menu li.menu-item-has-children');

            menuItems.forEach(function (menuLink) {
                var menuLinkIcon = document.createElement('div');
                menuLinkIcon.className = 'toggle-sub-menu';
                menuLink.appendChild(menuLinkIcon);

                menuLinkIcon.addEventListener('click', function (e) {
                    e.stopPropagation();

                    if (menuLink.classList.contains('is-open')) {
                        menuLink.classList.remove('is-open');
                    } else {
                        document.querySelectorAll('li.menu-item-has-children.is-open').forEach(function (item) {
                            item.classList.remove('is-open');
                        });
                        menuLink.classList.add('is-open');
                    }
                });
            });

            // Open current submenu
            document.querySelectorAll('.current-menu-parent').forEach(function (item) {
                item.classList.add('is-open');
            });
        });

        // Class for body indicating nav open status
        document.querySelectorAll('.mobile_menu_bar').forEach(function (bar) {
            bar.addEventListener('click', function () {
                document.body.classList.toggle('nav-is-open');
            });
        });
    }

    /*
    * Nav on-scroll changes
    -----------------------------------------------------*/
    function navScrollChange() {
        var scrollMin = 1;

        function update() {
            var scrolled = window.scrollY >= scrollMin;

            document.querySelectorAll('.navigation__container').forEach(function (nav) {
                nav.classList.toggle('scrolled', scrolled);
            });
        }

        window.addEventListener('scroll', update, { passive: true });
        update();
    }

    onReady(function () {
        enhanceNav();
        navScrollChange();
    });
})();
